type CurrencyTranslator = {
  instant(key: string, interpolateParams?: object): string;
};

export function localizedCurrencyLabel(
  translator: CurrencyTranslator,
  currency?: string | null,
  market?: number | null,
): string {
  const normalized = (currency ?? '').trim().toUpperCase() || (market === 2 ? 'USD' : 'EGP');
  const key = `COMMON.CURRENCY_${normalized}`;
  const translated = translator.instant(key);

  return translated && translated !== key ? translated : normalized;
}
